export default {"src":"https://marketing.bounce.com/_next/static/media/app-store.8e2e5059.svg","height":26,"width":102,"blurWidth":0,"blurHeight":0};